import styled, { css, keyframes } from "styled-components";

const blurAnim = keyframes`
  0%{
    transition-timing-function: cubic-bezier(0,0,.2,.93);
   filter:blur(0px)
  }
  
  100%{
     
    filter:blur(7px)
    }
`;
const scaleAnim = keyframes`
  0%{
    transition-timing-function: cubic-bezier(0.35, 0, 0.2, 1);
    transform: scale(1)
    }
  100%{
     transform: scale(.9);
  }
`;
const unBlurAnim = keyframes`
  0%{
    transition-timing-function: cubic-bezier(0,0,.2,.93);
   filter:blur(7px)
  }
  
  100%{
     
    filter:blur(0px)
    }
`;
const unscaleAnim = keyframes`
  0%{
    transition-timing-function: cubic-bezier(0.35, 0, 0.2, 1);
    transform: scale(.9);
  }
  100%{
    transform: scale(1);
  }
`;
const blur = css`
  ${blurAnim} 167ms 1 forwards, ${scaleAnim} 250ms 1 forwards
`;
const unBlur = css`
  ${unBlurAnim} 367ms 1 forwards, ${unscaleAnim} 367ms 1 forwards
`;
const fadeInAnim = keyframes`
  0%{
    transition-timing-function: cubic-bezier(0.42, 0, 0.07, 0.92);
     opacity:0;
     transform: scale(.65);
  }
  100%{
     transform: scale(1);
     opacity:1;
   } 
`;
const fadeIn = css`
  ${fadeInAnim} 467ms 1 forwards 200ms
`;
export const BlurBox = styled.div`
  opacity: ${(p) => (p.showLoading ? 0 : 1)};
  animation: ${(p) => (p.fadeInKeno ? fadeIn : null)};
  animation: ${(p) => (p.blur ? blur : null)};
  animation: ${(p) => (p.unBlur ? unBlur : null)};
  margin-top: -8px;
  /* position: relative; */
  height: 100%;

  /* max-height: 667px; */
  /* min-height: 600px; */

  /* display: flex;
  flex-direction: column;
  justify-content: space-between; */

  /* overflow: hidden; */
`;
